export default "__VITE_ASSET__1219b7d3__"